import type { Release } from '../releases.ts';

export default {
  version: '0.18.4',
  date: '2026-10-02',
  title: 'Sequence export with transitions',
  summary: [
    'Fixed: sequences with transitions export again in the PRISM containers, without the “xfade frame rate” error',
  ],
  features: [],
  fixes: ['Sequences with transitions export with the FFmpeg in the PRISM containers again (“xfade frame rate (1/0)”): every clip and transition is put on the sequence frame rate before the next transition'],
} satisfies Release;
